import { Component, OnInit, Input, ContentChildren, QueryList, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { 
    IonIcon
} from '@ionic/angular/standalone';

import { MarvTabComponent, MarvCircleComponent } from '@marv/components';

export class MarvTab {
    id: string;
    iconPrefix?: string;
    iconSuffix?: string;
    label?: string;
    countItems?: number;
    defaultSelected?: boolean = false;
    hide?: boolean = false;
}

@Component({
    selector: 'marv-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    imports: [CommonModule, IonIcon, forwardRef(() => MarvCircleComponent)]
})
export class MarvTabsComponent  implements OnInit {

    @Input({alias : 'tabs', required : true}) tabs: Array<MarvTab> = [];   
    
    @ContentChildren(MarvTabComponent, {descendants: true}) tabsContentList!: QueryList<MarvTabComponent>;
    
    selectedTab: MarvTab|null = null;

    constructor() { }

    ngOnInit() {
        this.selectedTab = this.tabs.find(t => t.defaultSelected) || null;
    }

    selectTab(tab: MarvTab) {
        this.selectedTab = tab;
    }

}
